import { Subscription } from '@sxm-de/dev-kits/microservices-sdk/types';
import { SxmTypeSubscription } from '@sxm-de/dev-kits/web-sdk/types';

export function mapSmsSubscriptionToSubscription(
    s: Subscription,
): SxmTypeSubscription {
    return {
        id: s.id,
        isDeviceEligible: (s.plans || []).some(
            (plan) => plan.hasRadioService === true,
        ),
        deviceId: s.radioService?.radioId ?? '',
        planIds: [...(s.plans ?? []), ...(s.followonPlans ?? [])].map(
            (plan) => `${s.id}-${plan.packageName}`,
        ),
        status: s.status ?? '',
        streamingCredentials: s.streamingService
            ? {
                  username: s.streamingService.userName,
                  maskedUsername: s.streamingService.maskedUserName ?? '',
                  hasRandomCredentials:
                      s.streamingService.randomCredentials === true,
              }
            : null,
    };
}

/**
 * TODO:
 * Refactor this to live somewhere common
 */
function parseDate(dateString: string): Date {
    return new Date(dateString);
}

/**
 * TODO:
 * Refactor this to live somewhere common
 */
function parseDateOptional(dateString: string | null | undefined): Date | null {
    if (!dateString) {
        return null;
    }
    return parseDate(dateString);
}
